import React from 'react';
import {Modal} from 'antd';
import {ArrowRightOutlined, ExclamationCircleOutlined} from '@ant-design/icons';

import './duplicateRegistrationWarning.css';

const DuplicateRegistrationWarningBody = ({
  fromStatusLabel,
  toStatusLabel,
  attendeeEmail,
  duplicateCount,
  duplicateRegistrations = [],
  fallbackMessage,
}) => {
  if (fallbackMessage && !fromStatusLabel) {
    return (
      <div className='duplicate-reg-warning'>
        <p className='duplicate-reg-warning__lead'>{fallbackMessage}</p>
        <p className='duplicate-reg-warning__hint'>
          Duplicate registrations will be marked as Registration Cancelled.
        </p>
      </div>
    );
  }

  const registrationWord = duplicateCount === 1 ? 'registration' : 'registrations';
  const duplicateIds = duplicateRegistrations.map((r) => `#${r.id}`).join(', ');

  return (
    <div className='duplicate-reg-warning'>
      <p className='duplicate-reg-warning__lead'>
        Updating this registration will cancel other duplicate To Be Paid{' '}
        {registrationWord} for the same email ({attendeeEmail}).
      </p>

      <div className='duplicate-reg-warning__card'>
        <div className='duplicate-reg-warning__row'>
          <span className='duplicate-reg-warning__label'>Status change</span>
          <div className='duplicate-reg-warning__status'>
            <span className='duplicate-reg-warning__tag'>{fromStatusLabel}</span>
            <ArrowRightOutlined className='duplicate-reg-warning__arrow' />
            <span className='duplicate-reg-warning__tag duplicate-reg-warning__tag--new'>
              {toStatusLabel}
            </span>
          </div>
        </div>
        <div className='duplicate-reg-warning__row'>
          <span className='duplicate-reg-warning__label'>To cancel</span>
          <span className='duplicate-reg-warning__value'>
            {duplicateCount} {registrationWord}
            {duplicateIds ? ` (${duplicateIds})` : ''}
          </span>
        </div>
      </div>
    </div>
  );
};

export const showDuplicateRegistrationWarningModal = ({
  fromStatusLabel,
  toStatusLabel,
  attendeeEmail,
  duplicateCount,
  duplicateRegistrations,
  fallbackMessage,
  onConfirm,
}) => {
  return new Promise((resolve) => {
    Modal.confirm({
      className: 'duplicate-reg-warning-modal',
      width: 480,
      centered: true,
      icon: null,
      title: (
        <div className='duplicate-reg-warning-modal__header'>
          <ExclamationCircleOutlined className='duplicate-reg-warning-modal__header-icon' />
          <div className='duplicate-reg-warning-modal__header-text'>
            <div className='duplicate-reg-warning-modal__title'>Duplicate registration</div>
            <div className='duplicate-reg-warning-modal__subtitle'>
              Confirm before proceeding
            </div>
          </div>
        </div>
      ),
      content: (
        <DuplicateRegistrationWarningBody
          fromStatusLabel={fromStatusLabel}
          toStatusLabel={toStatusLabel}
          attendeeEmail={attendeeEmail}
          duplicateCount={duplicateCount}
          duplicateRegistrations={duplicateRegistrations}
          fallbackMessage={fallbackMessage}
        />
      ),
      okText: 'Proceed',
      cancelText: 'Cancel',
      onOk: async () => {
        if (!onConfirm) {
          resolve(false);
          return;
        }
        const result = await onConfirm();
        resolve(result !== false);
      },
      onCancel: () => resolve(false),
    });
  });
};
